import { Button, Container } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LocalStorageService from 'services/LocalStorageService';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: 'white',
      background: theme.palette.primary.main,
      position: 'fixed',
      bottom: 0,
      right: 0,
      left: 0,
      padding: '0.5rem',
      boxShadow: theme.shadows[10],
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
);

const CookiesBanner = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [hasConsented, setHasConsented] = useState<boolean>(LocalStorageService.getHasConsented());

  const handleConsent = () => {
    LocalStorageService.cookiesConsented();
    setHasConsented(true);
  };

  if (hasConsented) return null;

  return (
    <div className={classes.root}>
      <Container className={classes.container}>
        {t('cookie_disclaimer')}
        <Button onClick={handleConsent} variant="contained">
          {t('cookie_understand')}
        </Button>
      </Container>
    </div>
  );
};

export default CookiesBanner;
